import merge from 'lodash/merge';

import bdcTheme from './blindscom';
import thdTheme from './homedepotcom';
import defaultTheme from './defaultTheme';

const themes = {
  3: bdcTheme,
  11: thdTheme,
};

const theme = siteId => merge(
  {},
  defaultTheme,
  themes[siteId],
);

export default theme;
